import ApiService from "../../../ApiService";

const EditUnitService = {
    loadScreenView: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bookgroup/editunit/loadscreenview", vo, successCallback, failureCallback);
    },
    saveUnit: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bookgroup/editunit/save", vo, successCallback, failureCallback);
    },
};

export default EditUnitService;